import React, { useEffect, useCallback, useState } from 'react'
import { useParams } from 'react-router'
import { Http } from '../../../helpers/axois'
import { useSelector } from 'react-redux'
import { logger } from '../../../constant/winston'
import { decodeBase64 } from '../../../helpers/commonFunction'
import { permissions as defaultPermissions, imports } from './createFunction/constants'
import { mapObjToTuple, getToggleData } from './createFunction/helpers/common'
import { IMarketplaceFn } from './createFunction/types'
import CreateFunction from './createFunction'
import { CreateMarketplaceFn } from '../../../helpers/RxServices'
import { Spinner } from '../../../helpers/commonUi'

const mapResourceToState = (fn: IMarketplaceFn) => {
  const context = JSON.parse(decodeBase64(fn.context))
  const {
    source,
    permissions,
    mode: executionMode,
    id,
    name,
    description,
    preview_image,
    current_version,
    release_notes,
    author_website,
    support_email,
  } = fn

  // too much manual work ???
  return {
    source: decodeBase64(source),
    context: {
      params: mapObjToTuple(context.params),
      a8config: mapObjToTuple(context.a8config),
      functions: context.functions,
    },
    permissions: {
      a8config: getToggleData(
        defaultPermissions.a8config,
        permissions.a8config
      ),
      a8flow: getToggleData(defaultPermissions.a8flow, permissions.a8flow),
      a8Astro: getToggleData(defaultPermissions.a8Astro, permissions.a8Astro || []),
      a8func: getToggleData(permissions.a8func, permissions.a8func) // noice trick!
    },
    imports: getToggleData(imports, []),
    executionMode,
    metadata: {
      id,
      name,
      description,
      preview_image,
      current_version,
      release_notes,
      author_website,
      support_email,
    },
  }
}

export const EditFunction = () => {
  const [state, setState] = useState<any>({
    metadata: {},
  })
  const orgId = useSelector((state: any) => state.org.selectedOrg.id)
  const params = useParams<{ functionId: string }>()
  const { functionId } = params

  const getFunction = useCallback(
    async (id: string) => {
      const endpoint = `/orgs/${orgId}/marketplaceFunctions/${id}`
      try {
        const res:any = await Http.get(endpoint).toPromise()
        const state = mapResourceToState(res?.data)
        CreateMarketplaceFn.sendMessage({
          message: 'sendMetadata',
          data: { metadata: state.metadata }
        })
        setState(state)
      } catch (err) {
        logger.error('failed to get function: ', err)
      }
    },
    [orgId]
  )

  useEffect(() => {
    getFunction(functionId)
  }, [functionId, getFunction])

  if(!state.metadata.id) {
    return <Spinner />
  }

  return <CreateFunction state={state} />
}
